<cs-header [backButton]="true" [fullWidth]="true" [separator]="true">
  <cs-header-title>{{ LL.trainingOverview.title() }}</cs-header-title>
</cs-header>

<cs-content>
  @if (!coachingDashboardOn) {
    <!-- the page is behind the coaching dashboard switch (#5456): with it off, nothing is loaded or shown -->
    <div class="overview-body not-available">{{ LL.trainingOverview.notAvailable() }}</div>
  } @else {
    <div class="overview-body">
      <cs-training-overview [model]="model" [canShowEarlier]="canShowEarlier" [busy]="busy" [failed]="failed"
        [loadedWeeks]="loadedWeeks" (retry)="onRetry()" (rowTap)="onRowTap($event)" (showEarlier)="onShowEarlier($event)">
        @if (olderLogsDownloading) {
          <cs-note class="older-downloading">{{ LL.trainingOverview.olderDownloading() }}</cs-note>
        }
      </cs-training-overview>
    </div>
  }
</cs-content>
